/* eslint-disable react/no-unescaped-entities */
/* eslint-disable sentence-case/sentence-case */
import { createServerClient } from "@graph/client"
import { Heading } from "@ui/heading"
import { TopbarLayout } from "@layouts/topbar"
import { PageBlock } from "@ui/page-block"
import { GetServerSideProps } from "next"
import DEFAULT_QUERY from "@graph/queries/default.gql"
import { DefaultQuery } from "@graph/types/DefaultQuery"

export default function TermsOfServicePage() {
  return (
    <TopbarLayout title="Terms of Service">
      <PageBlock gap="3">
        <Heading as="h1" level="1">
          Terms Of Service
        </Heading>
        <p> Last updated: November 30, 2021 </p>
        <p>
          These Terms of Use set out the terms and conditions under which individuals may use the website and access the
          services offered by Careguide Inc. (dba HeartPayroll, ("HeartPayroll")). These Terms of Use comprise a legal
          agreement between HeartPayroll and you, the person accessing and using the website ("You" or "User").
          HeartPayroll owns, operates and maintains the HeartPayroll website at HeartPayroll.com and other subsidiary
          websites (collectively referred to as "Website" or " the Platform"). By accessing and/or using the Platform,
          you are deemed to have read these Terms of Use and you agree to be bound by the Terms of Use which shall
          govern your access and use of the Platform and all applicable laws and regulations.{" "}
        </p>
        <Heading as="h4" level="2">
          {" "}
          1. Description of Services{" "}
        </Heading>
        <p>
          HeartPayroll provides household employers with complete payroll and tax services to salaried or hourly
          employees, including nannies, caregivers, or other individuals and/or entities providing care services
          (“Service Providers”).
        </p>
        <p>
          {" "}
          HeartPayroll offers complete payroll management services and customer support for your household’s payroll and
          taxes, including payroll calculation (calculation of net and gross pay), payroll statement production, payment
          processing and payments through direct deposit, Canada Revenue Agency (CRA) registration, Workplace Safety and
          Insurance Board (WSIB) (formerly Workers' Compensation Board) or WorkSafeBC registration, production and
          filing of T4s, T4 summaries and Records of Employment, and calculation and remittance of all source
          deductions, including taxes, Canadian Pension Plan (CPP) and Employment Insurance (EI) amounts, WSIB or
          WorkSafeBC premiums and any other required adjustments (collectively referred to as “Services”).{" "}
        </p>
        <p> Please refer to the Website regularly for further information about the Services provided. </p>

        <Heading as="h4" level="2">
          {" "}
          2. Eligibility Criteria{" "}
        </Heading>
        <p>
          To be eligible to use the Services offered by HeartPayroll, you represent and warrant as follows: that you are
          eighteen (18) years of age or older on the date of creation of your User Account; if you are registering as
          Service Provider, that you are legally permitted to work in the jurisdiction where you are seeking employment;
          and neither you nor any member of your household have ever been the subject of a complaint, restraining order
          or any other legal action or criminal offence involving violence, abuse, neglect, fraud, or any other offence
          that involves endangering the safety of others, and that you are not registered or currently required to
          register as a sex offender with any government agency in any jurisdiction.
        </p>
        <Heading as="h4" level="2">
          3. Payroll Services’ Specific Terms
        </Heading>
        <p>
          HeartPayroll offers its users (“Users”) access to a platform that facilitates the payment from you to the
          Service Provider. Before using HeartPayroll’s Services, you will be required to agree that you have read and
          agree with these terms regarding HeartPayroll’s Services and processing of your “Personal Information”
          (meaning any information about an identifiable individual, such as your name, e-mail address, mailing
          addresses, date of birth, any data about you that you elect to provide and any other information that
          identifies who you are), including Financial Information (defined below) collected, stored and used by
          HeartPayroll. Your agreement to these terms is required in order to use the Services and indicates your
          consent for HeartPayroll to process your Personal and Financial Information for the purposes identified. Your
          Personal Information will be used by HeartPayroll solely in accordance with the terms below and the Company’s
          Privacy Policy, which can be accessed by visiting www.CareGuide.com/privacy.
        </p>
        <p>
          You agree that you will: (a) maintain and update the Personal Information you provide to HeartPayroll
          (including Financial Information (defined below)) as necessary in order to keep such information current,
          complete, and accurate; (b) maintain the confidentiality of any passwords or other account identifiers which
          you choose or that are assigned to you as a result of any registration or account creation with the Website;
          and (c) be responsible for all activities that occur under such password or account. Further, you agree to
          immediately notify HeartPayroll of any unauthorized use of your password or account in the event that the
          confidentiality of your password or your account is compromised. Failure to comply with this paragraph may
          result in immediate termination of your account. If you elect to use and register for HeartPayroll’s Services,
          the following terms and conditions apply to you.
        </p>
        <Heading as="h5" level="3">
          a. Financial Information
        </Heading>
        <p>
          If you elect to register for HeartPayroll’s Services, certain sensitive information, including your Social
          Insurance Number and certain financial information including bank account number(s) (collectively referred to
          as “Financial Information”) are required to be collected when you sign up for a User Account. By registering
          for HeartPayroll’s Services, you hereby consent to the voluntary provision of this Financial Information as
          required for the processing of payroll and taxes in connection with the employment of Service Providers.
        </p>
        <Heading as="h5" level="3">
          b. Business Pre-authorized Debit Authorization (“Business PAD Authorization”)
        </Heading>
        <p>
          You expressly authorize the Company and its payroll service provider, Wagepoint Inc. (or any other service
          provider that the Company may appoint from time to time) on its behalf or as agent for any assignee to access
          the bank account identified by you in your HeartPayroll registration material (or any new bank account that
          you identify to the Company from time to time) for all withdrawals and payments to the Company described in
          these Terms of Service, and to correct any debit errors. Each regular debit for Default Payroll and the
          Service Fee will be withdrawn from your bank account in accordance with the Withdrawal Date designated below
          in "d. Pay Dates". You understand that your regular PAD withdrawals will be the default salary amount or daily
          hourly worked total, default processing dates, and default deductions you specified during registration or a
          variable amount that you report to HeartPayroll at lease 7 days prior to the Pay Date. Any debit required to
          correct any debit error or otherwise in respect of a payment described under these Terms of Service that is
          owing to the Company but has not been collected from you will be withdrawn from your bank account on the next
          Withdrawal Date or on or about the date that the Company advises you. If any debit is dishonoured or not
          processed by your bank for any reason, you agree that the Company may issue another debit in substitution for
          the dishonoured debit.
        </p>
        <p>
          You understand that you may cancel this Business PAD Authorization any time upon thirty (30) days’ written
          notice to the Company, however, if you do so, you will be obligated to make all payments described in these
          Terms of Service. If you cancel this Business PAD Authorization, HeartPayroll will be unable to provide the
          Services to you. To obtain a sample cancellation form, or for more information on your rights to cancel, you
          may contact your bank or visit www.payments.ca. You have certain recourse rights if any debit does not comply
          with this PAD Authorization. To obtain a form or for a reimbursement claim or for more information on your
          recourse rights, you may contact your bank or visit www.payments.ca.
        </p>
        <Heading as="h5" level="3">
          c. Payroll Services
        </Heading>
        <p>
          HeartPayroll’s Services will calculate payroll deductions for each Service Provider under your employment.
          HeartPayroll shall be responsible for withholding and remitting your statutory remittances including income
          tax, employment insurances, government pension plans, and other government remittances relating to payroll.
        </p>
        <Heading as="h5" level="3">
          d. Pay Dates
        </Heading>
        <p>The following dates and terms will apply the Services:</p>
        <p>
          i. Default Payroll – Based on information provided by you in your registration to HeartPayroll, you will have
          a default salary amount or daily hourly worked total, default processing dates, and default deductions that
          will be processed 3-4 business days prior to the Pay Date. The Service Provider will be paid according to the
          default payroll instructions, unless you provide HeartPayroll updates by 11:59 a.m. EST on the business day
          that immediately follows the day you receive the email reminder (which is sent one week prior to the Pay
          Date).
        </p>
        <p>
          ii. Withdrawal Date – the date the funds are withdrawn from your bank account. This date will be 3 or 4
          business days prior to the Pay Date.
        </p>
        <p>iii. Pay Date – the date the funds are deposited into the Service Providers’ bank account</p>
        <p>
          iv. You agree to provide a void cheque or relevant Financial Information for payment of the Service Provider.
        </p>
        <Heading as="h5" level="3">
          e. Service Provider Changes or Termination
        </Heading>
        <p>
          YOU AGREE TO INFORM THE COMPANY IMMEDIATELY IN WRITING OF ANY CHANGE IN THE EMPLOYMENT STATUS OF YOUR SERVICE
          PROVIDER(S), including employment hours, resignation, termination, leave of absence, or extended holidays. You
          are aware and agree that failure to inform HeartPayroll of a Service Provider’s end of employment may cause
          the Service Provider to be paid unnecessarily, or incorrectly, and you will be responsible should this occur.
        </p>
        <Heading as="h5" level="3">
          f. Vacation Pay
        </Heading>
        <p>
          When you register for HeartPayroll’s services, you agree that any eligible vacation pay will be paid to the
          Service Provider when he/she takes vacation time (referred to as “Accrued Vacation Pay”). Unless you notify
          HeartPayroll of an alternative method for vacation pay, vacation pay will be paid to the service provider on
          an accrued vacation pay basis. Alternatively, if you agree with the Service Provider, in writing, that his/her
          eligible vacation pay will be paid at an appropriate rate on each pay cheque for each pay period, and no
          Accrued Vacation Pay will be paid, you must provide notice to HeartPayroll to implement this method of
          vacation pay.
        </p>
        <p>
          The amount of vacation pay will be indicated on the pay cheque to the Service Provider, and pay report to you,
          separate from any other amounts paid to the Service Provider. You may also request that HeartPayroll provide a
          separate pay report for the vacation pay being paid.
        </p>
        <Heading as="h5" level="3">
          g. Termination of Account
        </Heading>
        <p>
          Either party may terminate, withdraw, or discontinue all or part of the Services by notifying the other party
          in writing with a minimum of 30 calendar days’ notice.
        </p>
        <Heading as="h4" level="2">
          4. User Account Fees, Term and Renewal
        </Heading>
        <p>
          a. HeartPayroll charges a fee for the Services. These fees are documented on our website, and can be found at
          https://www.heartpayroll.com/pricing
        </p>
        <p>
          b. Insufficient Funds.{" "}
          <strong>
            {" "}
            You are responsible for ensuring that there are sufficient funds in the bank account provided in this
            section of the Terms of Service. Charges for “Not Sufficient Funds” in your bank account are $65.00 CAD per
            occurrence.{" "}
          </strong>
        </p>
        <p>c. Rate and fee may be changed at any time on not less than 60 days prior written notice to you.</p>
        <p>
          d. You agree that the monthly Service Fee agreed to be paid to HeartPayroll shall form part of the payroll
          funds to be supplied to HeartPayroll. HeartPayroll shall not deposit pay for the Service Provider until it has
          received cleared funds from you.
        </p>
        <p>
          e. Early cancellation: You agree that if you cancel your service after signing the terms of service but less
          than 30 days after the first payroll is issued you will be charged a $75 administrative fee for account
          set-up.
        </p>
        <p>
          f. You agree that any fees associated with the use of HeartPayroll's Services are considered final payments
          and are non-refundable.
        </p>
        <Heading as="h4" level="2">
          5. Personal Information
        </Heading>
        <p>
          You agree that your use of the Website and the Services is subject to the terms of our Privacy Policy , which
          is hereby incorporated by reference into, and forms an integral part of, the Terms of Use. By using the
          Platform, you expressly consent to the collection, storage, use and disclosure of your information, including
          your Personal Information, according to the Privacy Policy.
        </p>
        <p>
          You represent and warrant to HeartPayroll that you are at least 18 years of age or have the permission of a
          parent or legal guardian (if between the ages of 13 – 18), and that you have the full, unrestricted right and
          authority and have been fully authorized to provide to HeartPayroll any and all Registration Data (including
          any Personal Information) for the purposes of these Terms of Use and that HeartPayroll is authorized and
          permitted to use such data as and to the extent provided in these Terms of Use and the Privacy Policy.
        </p>
        <Heading as="h4" level="2">
          6. Content and Use of Services
        </Heading>
        <p>
          As an Employer, Service Provider or any other User of the Services, you agree that the content of information
          and materials posted on the Website by You is accurate, current and complete. In addition, you represent and
          warrant as follows:
        </p>
        <p>
          a. You will use the Services provided by HeartPayroll solely for yourself and are responsible for all activity
          and use of your account and may not assign or transfer your account to any other person.
        </p>
        <p>b. You have the right and authority to post all information you post about yourself or others.</p>
        <p>
          c. You will not provide inaccurate, misleading, defamatory or false information to HeartPayroll or to any
          other User of the Website.
        </p>
        <p>
          d. You will not post any content (including, but not limited to, written material, text, photos, or graphical
          content) on the Website, or transmit to other users, that is defamatory, inaccurate, inappropriate, abusive,
          obscene, profane, offensive, sexually oriented, threatening, harassing, defamatory, racially offensive, or
          illegal material, or any material that infringes or violates another party's rights (including, but not
          limited to, intellectual property rights, and rights of privacy and publicity), or advocate, promote or assist
          any unlawful act.
        </p>
        <p>
          e. Your use of the Website and Services provided by HeartPayroll are in accordance with any and all applicable
          laws and regulations.
        </p>
        <Heading as="h4" level="2">
          7. Use License
        </Heading>
        <p>
          HeartPayroll hereby grants you a limited, non-exclusive, personal, non-transferable, non-sub-licensable and
          revocable right and license to:
        </p>
        <p>
          a. access the Platform for the purpose of receiving the Services in accordance with these Terms of Use; and
        </p>
        <p>
          b. access, view and print any information and documentation made available on the Website or App, for your
          personal, non-commercial and informational use only to assist you in the access and use of the Website or App
          and the Services.
        </p>
        <p>
          These Terms of Use do not grant you any other right or license, whether express or implied, by estoppel, or
          otherwise in or under any patent, trademark, copyright, or other intellectual property or proprietary right of
          HeartPayroll or any third party.
        </p>
        <p>HeartPayroll may terminate this license at any time for any reason whatsoever.</p>
        <Heading as="h4" level="2">
          8. Intellectual Property
        </Heading>
        <p>The Platform and all intellectual property rights in the Platform are owned by HeartPayroll.</p>
        <p>
          HeartPayroll reserves all intellectual property rights, including but not limited to, copyright, trade-marks,
          domain names, design rights, brand elements, database rights, patents, and all other intellectual property
          rights of any kind, whether registered or unregistered.
        </p>
        <Heading as="h4" level="2">
          9. Trade-marks
        </Heading>
        <p>
          All brand elements, company name, website names, logos, registered and unregistered trade-marks displayed on
          the Platform or used in connection with the Services are the trade-marks of HeartPayroll (or its suppliers,
          partner businesses or third party licensors).
        </p>
        <p>
          Any use or misuse of any trade-marks or brand elements of HeartPayroll or any other content appearing on the
          Platform or in connection with the Services except as provided in these Terms of Use or with the express
          written consent of HeartPayroll is strictly prohibited.
        </p>
        <p>
          Nothing contained on the Platform shall be construed as an express or implied grant of any license or right to
          use any trade-mark or brand element without prior written consent of HeartPayroll.
        </p>
        <Heading as="h4" level="2">
          10. Use Restrictions
        </Heading>
        <p>
          In addition to complying with these Terms of Use, you agree to use the Platform and Services for lawful
          purposes only and in a manner consistent with all applicable local, national or international laws and
          regulations, including all privacy and personal information laws.
        </p>
        <p>The Website and any Services shall not be used where, and to any extent, such use is prohibited by law.</p>
        <p>
          HeartPayroll encourages all Users to report any misconduct, misuse or unlawful activities of other Users,
          including, but not limited to activities on the Platform and in connection with the Services provided.
        </p>
        <p>Please contact HeartPayroll by email at payroll@heartpayroll.com.</p>
        <Heading as="h4" level="2">
          11. Termination of Registration
        </Heading>
        <p>
          HeartPayroll reserves the right, in its sole discretion, to terminate your account or access to part or all of
          HeartPayroll’s Website or Services in the event that HeartPayroll determines you are not eligible to use the
          Services or have violated any of the provisions of the Terms of Use, or have misused the Website, App or
          Services in any way.
        </p>
        <Heading as="h4" level="2">
          12. Limitation of Liability
        </Heading>
        <p>
          YOU ACKNOWLEDGE THAT ANY USE OF OR RELIANCE ON THIS WEBSITE OR THE SERVICES IS COMPLETELY AT YOUR OWN RISK.
        </p>
        <p>
          UNDER NO CIRCUMSTANCES SHALL HEARTPAYROLL BE LIABLE TO YOU OR TO ANY OTHER PARTY, FOR ANY LOSSES, COSTS OR
          DAMAGES OF ANY KIND OR NATURE WHATSOEVER THAT ARE SUFFERED OR INCURRED IN ANY CONNECTION WITH THE USE OF (OR
          THE INABILITY TO USE) THE PLATFORM, SERVICES, OR ANY HEARTPAYROLL CONTENT OR THIRD PARTY CONTENT (REGARDLESS
          OF THE FORM OF ACTION OR THEORY OF LIABILITY, INCLUDING FOR BREACH OF CONTRACT, TORT, NEGLIGENCE, EQUITY,
          STRICT LIABILITY, BY STATUTE OR OTHERWISE AND REGARDLESS OF THE OCCURRENCE OF A FUNDAMENTAL BREACH OR FAILURE
          OF ESSENTIAL PURPOSE).
        </p>
        <p>
          IN NO EVENT WHATSOEVER SHALL ANY OF HEARTPAYROLL, ITS DIRECTORS, OFFICERS, EMPLOYEES, SHAREHOLDERS,
          AFFILIATES, AGENTS AND THIRD-PARTY CONTRACTORS, SUPPLIERS AND LICENSORS (COLLECTIVELY THE "COMPANY PARTIES")
          BE LIABLE FOR ANY SPECIAL, EXEMPLARY, PUNITIVE, CONSEQUENTIAL, INCIDENTAL OR INDIRECT DAMAGES OF ANY KIND OR
          NATURE WHATSOEVER THAT ARE SUFFERED OR INCURRED IN ANY CONNECTION WITH THE USE OF PLATFORM OR THE PROVISION OF
          THE SERVICES (INCLUDING IN ANY CONNECTION WITH THE TRANSMISSION OR DOWNLOADING OR STORAGE OF ANY DATA OR
          SUBMISSIONS TO OR FROM THE PLATFORM OR THE USE OF, OR RELIANCE ON, ANY HEARTPAYROLL CONTENT OR OTHER
          INFORMATION OR DATA CONTAINED ON OR PROVIDED THROUGH THE PLATFORM, OR SERVICES, OR LOSS OF OR DAMAGE TO FILES
          OR DATA OR ANY COSTS OF RECOVERING OR REPRODUCING ANY FILES OR DATA OR LOSS OF USE OR LACK OF AVAILABILITY OF
          SERVICES OR ANY BUSINESS INTERRUPTION OR LOSS OF REVENUE OR PROFIT OR ANY OTHER ECONOMIC LOSS WHATSOEVER)
          HOWEVER CAUSED AND REGARDLESS OF THE FORM OR CAUSE OF ACTION AND WHETHER OR NOT FORESEEABLE, EVEN IF THE
          HEARTPAYROLL PARTIES OR ANY OF THEM HAS BEEN INFORMED IN ADVANCE OR OUGHT REASONABLY TO HAVE KNOWN OF THE
          POTENTIAL FOR SUCH DAMAGES.
        </p>
        <Heading as="h4" level="2">
          13. Indemnification
        </Heading>
        <p>
          You agree to indemnify and hold HeartPayroll, its parents, subsidiaries, affiliates, officers and employees,
          harmless from any claim, demand, or damage, including reasonable legal fees, asserted by any third party due
          to or arising out of the Users use of or conduct respecting the Services, and Platform.
        </p>
        <Heading as="h4" level="2">
          14. Miscellaneous
        </Heading>
        <Heading as="h5" level="3">
          a. Governing Law
        </Heading>
        <p>
          The Platform is administered by HeartPayroll from a site that is located in Ontario, Canada. You acknowledge
          and agree that your use of the Platform and all of the communications, transmissions and transactions
          associated with the Website and the provision of the Services shall be deemed to have occurred in the Province
          of Ontario, Canada. You agree that these Terms of Use shall be exclusively governed by, construed and
          interpreted in accordance with the laws of the Province of Ontario, Canada and the federal laws of Canada
          applicable therein. In the event of a dispute under these Terms of Use, such dispute shall be resolved in the
          Courts of the Province of Ontario.
        </p>
        <Heading as="h5" level="3">
          b. Language
        </Heading>
        <p>
          It is the express will of HeartPayroll that these Terms of Use and all related documents on the Platform are
          in English.
        </p>
        <Heading as="h5" level="3">
          c. Non-assignment
        </Heading>
        <p>
          These Terms of Use are not assignable, transferable, or to be sub-licensed by you except with HeartPayroll's
          prior written consent. HeartPayroll may assign, transfer, or delegate any of its rights and obligations
          hereunder without your consent.
        </p>
        <Heading as="h5" level="3">
          d. Modifications of Terms of Use
        </Heading>
        <p>
          HeartPayroll may revise these Terms of Use at any time without notice. By using the Platform, you are agreeing
          to be bound by the current version of the Terms of Use and Privacy Policy (last updated date listed at the top
          of the Terms of Use).
        </p>
        <p>
          The content and material appearing on the Platform could include technical, typographical or photographic
          errors. HeartPayroll does not warrant that any of the materials provided are accurate or current.
        </p>
        <Heading as="h5" level="3">
          e. Links to External Websites
        </Heading>
        <p>
          The links on the Platform to other websites or resources, including those operated by parties other than
          HeartPayroll are provided for your convenience. HeartPayroll is not responsible for the availability of such
          websites or resources and does not endorse or accept responsibility for the content of such external websites
          or resources and has no responsibility for or control over the terms of service or privacy policy (if any) of
          the operators of the external websites or resources.
        </p>
        <p>Your access and viewing of any third party websites or resources is conducted at your own risk.</p>
        <Heading as="h5" level="3">
          f. Website and Services Provided "As Is"
        </Heading>
        <p>
          YOU UNDERSTAND AND AGREE THAT THE PLATFORM, THE SERVICES, ANY CONTENT AND OTHER INFORMATION, DATA AND
          MATERIALS AVAILABLE ON THE WEBSITE, OR PROVIDED AS PART OF THE SERVICES, ARE PROVIDED ON AN "AS IS" AND "AS
          AVAILABLE" BASIS.
        </p>
        <Heading as="h5" level="3">
          g. Contact Us
        </Heading>
        <p>
          If you have any questions about the Terms of Use, or need to provide notice to, or communicate with,
          HeartPayroll under the Term of Use, please contact HeartPayroll by clicking Contact Us , or by delivery in
          person, by courier or by the mail, to Company at:
          <br />
          1100-20 Bay Street
          <br />
          Toronto, ON
          <br />
          M5J 2N8
        </p>
      </PageBlock>
    </TopbarLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const client = createServerClient({ headers: ctx.req.headers })

  const { data } = await client.query<DefaultQuery>({
    query: DEFAULT_QUERY,
  })

  return { props: data }
}
